var _context;

import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
export default _bindInstanceProperty(_context = _Array$isArray).call(_context, Array);